import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FServiceAPI } from '@freelog/tools-lib';
import { decompile } from '@freelog/nmr_translator';
import { ruleMatchAndResult } from '@/models/informalNodeManagerPage';
import type { IRules, RuleMatchAndResultReturn } from '@/models/informalNodeManagerPage';
import fMessage from '@/components/fMessage';
import { mergeRules } from './helpers';
import type {
  ChangeAction,
  FetchInformalExhibitInfoAction,
  OnConfirm_CustomOptionsDrawer_Action,
  OnCancel_CustomOptionsDrawer_Action,
  OnConfirm_CustomOptionDrawer_Action,
  OnCancel_CustomOptionDrawer_Action,
} from './types';

export const drawerEffects = {
  * onConfirm_CustomOptionsDrawer({ payload }: OnConfirm_CustomOptionsDrawer_Action, {
    select,
    put,
    call,
  }: EffectsCommandMap) {
    // Implementation is commented out in original - empty effect
  },
  * onCancel_CustomOptionsDrawer({}: OnCancel_CustomOptionsDrawer_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_CustomOptionsDrawer_Visible: false,
      },
    });
  },
  * onConfirm_CustomOptionDrawer({ payload }: OnConfirm_CustomOptionDrawer_Action, {
    select,
    call,
    put,
  }: EffectsCommandMap) {
    const { informExhibitInfoPage }: ConnectState = yield select(({ informExhibitInfoPage }: ConnectState) => ({
      informExhibitInfoPage,
    }));

    const rules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = (informExhibitInfoPage.node_RuleInfo?.testRules || []).map((rr) => {
      return rr.ruleInfo;
    });

    let needHandleRules: Array<IRules['add'] | IRules['alter'] | IRules['activate_theme']> = JSON.parse(JSON.stringify(rules));

    needHandleRules = needHandleRules.map((nhr) => {
      if (nhr.exhibitName === informExhibitInfoPage.exhibit_Name && nhr.operation !== 'activate_theme') {
        return {
          ...nhr,
          actions: nhr.actions.filter((a) => {
            return !((a.operation === 'add_attr' || a.operation === 'delete_attr') && a.content.key === payload.value.key);
          }),
        };
      }
      return nhr;
    });

    needHandleRules = mergeRules({
      oldRules: needHandleRules,
      exhibitName: informExhibitInfoPage.exhibit_Name,
      action: {
        operation: 'add_attr',
        content: {
          key: payload.value.key,
          value: payload.value.value,
          description: payload.value.description,
        },
      },
    });
    const text: string = decompile(needHandleRules);

    const params: Parameters<typeof FServiceAPI.InformalNode.createRules>[0] = {
      nodeId: informExhibitInfoPage.node_ID,
      testRuleText: text,
    };
    const { data, errCode, ret, msg }: {
      data: boolean;
      errCode: number;
      msg: string;
      ret: number;
    } = yield call(FServiceAPI.InformalNode.createRules, params);

    if (ret !== 0 || errCode !== 0 || !data) {
      return fMessage(msg, 'error');
    }
    fMessage('自定义选项已更新');

    const params2: Parameters<typeof ruleMatchAndResult>[0] = {
      nodeID: informExhibitInfoPage.node_ID,
      isRematch: true,
    };

    const result: RuleMatchAndResultReturn = yield call(ruleMatchAndResult, params2);
    if (result.status === 2) {
      fMessage('规则匹配失败');
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_RuleInfo: result,
        side_CustomOptionDrawer_Visible: false,
        side_CustomOptionDrawer_DataSource: null,
      },
    });

    yield put<FetchInformalExhibitInfoAction>({
      type: 'fetchInformalExhibitInfo',
    });
  },
  * onCancel_CustomOptionDrawer({}: OnCancel_CustomOptionDrawer_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_CustomOptionDrawer_Visible: false,
        side_CustomOptionDrawer_DataSource: null,
      },
    });
  },
};
